"use client";

import type { ReactNode } from "react";
import { useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";
import { parseAreaAbility } from "./area-g3-format";

/**
 * Surf pages: switches a server-rendered part of the hero (the verdict line, the best card) to its
 * "Beginner and intermediate" version while the ranked board's ability filter asks for it
 * (`?difficulty=beginner`, AreaBoardControls). Both versions are built on the server from the same
 * pure verdict, so the client carries two small trees rather than the board. The server HTML and
 * the first client render always show the default; "Experienced only" keeps it too, because
 * experienced surfers can surf every spot listed.
 */
export function AreaAbilitySwitch({ all, beginner }: Readonly<{ all: ReactNode; beginner: ReactNode }>) {
  const ability = parseAreaAbility(useShallowSearchParam("difficulty"));
  return <>{ability === "beginner" ? beginner : all}</>;
}
